export default {
  inserted(el, binding) {
    el.addEventListener('mouseenter', function() {
      binding.value.cb(el, ...binding.value.args);
    });
    el.addEventListener('mouseleave', function() {
      binding.value.cb(el);
    });
  },
};
